import React, { useEffect, useId, useRef, useState } from "react";
import styles from "./ModelInfo.module.scss";
import close from "../../../images/icons/AdminPanel/close.svg";
import upload from "../../../images/icons/AdminPanel/sim_card_download.svg";
import AvatarUploader from "../ui/ImageUploader/AvatarUploader";
import { Button } from "../ui";

interface ImageProps {
  image: string | null; // Текущее изображение (может быть null, если изображение не загружено)
  setImage: (value: string | null) => void; // Функция для обновления изображения
  handleImageRemove: () => void; // Функция для удаления изображения
  patchUserAvatar: () => void; // Функция для удаления изображения
  photo: string | null | undefined;
}

const AvatarPopup: React.FC<ImageProps> = ({
  image,
  setImage,
  handleImageRemove,
  patchUserAvatar,
  photo,
}) => {
  const popupRef = useRef<HTMLDivElement>(null);
  const [isPopupVisible, setPopupVisible] = useState(false);

  const closePopup = () => {
    setPopupVisible(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target as Node)
      ) {
        closePopup();
      }
    };

    if (isPopupVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPopupVisible]);

  const handleClick = () => {
    if (isPopupVisible) {
      setPopupVisible(false);
    } else {
      setPopupVisible(true);
    }
  };
  return (
    <div ref={popupRef} className={styles.notifyAvatar}>
      {photo ? (
        <img
          src={photo}
          alt="Model photo"
          onClick={handleClick}
          className={styles.photo}
        />
      ) : (
        <div className={styles.photo__placeholder} onClick={handleClick}></div>
      )}

      {isPopupVisible && (
        <div className={styles.avatarPopup}>
          <div className={styles.NewPhoto} style={{ width: "100%" }}>
            <AvatarUploader
              image={image}
              setImage={setImage}
              handleImageRemove={handleImageRemove}
            />
            <div className={styles.Button}>
              <Button onClick={patchUserAvatar}>Save</Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AvatarPopup;
